import NextLink, { LinkProps } from 'next/link'
import { FC } from 'react'
import styled from 'styled-components'
import { width, height, padding, color } from 'styled-system'

type Props = LinkProps & Rest & { textDecoration?: string }

const Link: FC<Props> = ({
  children,
  textDecoration,
  href,
  as,
  replace,
  scroll,
  shallow,
  prefetch = false,
  locale,
  passHref = true,
  ...domProps
}) => {
  return (
    <NextLink
      href={href}
      as={as}
      replace={replace}
      scroll={scroll}
      shallow={shallow}
      prefetch={prefetch}
      locale={locale}
      passHref={passHref}
    >
      <StyledA decoration={textDecoration} {...domProps}>
        {children}
      </StyledA>
    </NextLink>
  )
}

export default Link

export const StyledA = styled.a`
  width: inherit;
  color: inherit;
  text-decoration: ${(props) => props.decoration ?? 'none'};
  display: inherit;
  cursor: pointer;
  ${width};
  ${height};
  ${padding};
  ${color};
`
